import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Every organization is granted an organization scope, a unique namespace for packages owned by the organization that matches the organization name. For example, an organization named "wombat" would have the scope `}<inlineCode parentName="p">{`@wombat`}</inlineCode>{`.`}</p>
    <p>{`You can use scopes to:`}</p>
    <ul>
      <li parentName="ul">{`Maintain a fork of a package: `}<inlineCode parentName="li">{`@wombat/request`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Avoid name disputes with popular names: `}<inlineCode parentName="li">{`@wombat/web`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Easily find packages in the same namespace`}</li>
    </ul>
    <p>{`Packages in a scope must follow the same `}<a parentName="p" {...{
        "href": "/files/package.json#name"
      }}>{`naming guidelines`}</a>{` as unscoped packages.`}</p>
    <h2>{`Managing unscoped packages`}</h2>
    <p>{`While you are granted a scope by default when you create an organization, you can also use organizations to manage unscoped packages, or packages under a different scope (such as a user scope).`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      